const admin_tools = [
    {
        name: 'Service Monitoring',
        key: 'service_monitoring',
        url: {name: 'service_monitoring'}
    },
];

const state = () => ({
    admin_tools
})

const actions = {}

const mutations = {}

const getters = {
    user_admin_tools(state, getters, rootState) {
        return state.admin_tools.filter(t => rootState.auth.data.permissions.tools.includes(t.key))
    },
    all_tools(state, getters, rootState){
        return rootState.auth.data.permissions.tools
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}